import type { ServiceClassesTranslationMessages } from './serviceClassesTranslationMessages';

export const serviceClassesLanguageFrench: ServiceClassesTranslationMessages = {
  service_classes: {
    name: 'Classes de service',
    fields: {
      id: 'ID',
      name: 'Nom',
      is_default: 'Défaut',
      description: 'Description',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      office_hours: {
        start_time: 'Heure de début',
        end_time: 'Heure de fin',
        weekday: 'Jour de la semaine',
        weekdays: {
          mo: 'Lundi',
          tu: 'Mardi',
          we: 'Mercredi',
          th: 'Jeudi',
          fr: 'Vendredi',
          sa: 'Samedi',
          su: 'Dimanche',
        },
      },
      password_policy: {
        history: 'Historique des mots de passe',
        lowercase: 'Nombre minimum de caractères minuscules',
        max_length: 'Longueur maximale',
        min_length: 'Longueur minimale',
        numbers: 'Nombre minimum de chiffres',
        special: 'Nombre minimum de caractères spéciaux',
        uppercase: 'Nombre minimum de caractères majuscules',
      },
      sip_password_policy: {
        history: 'Historique des mots de passe',
        lowercase: 'Nombre minimum de caractères minuscules',
        max_length: 'Longueur maximale',
        min_length: 'Longueur minimale',
        numbers: 'Nombre minimum de chiffres',
        special: 'Nombre minimum de caractères spéciaux',
        uppercase: 'Nombre minimum de caractères majuscules',
      },
      users_policy: {
        account_disable_when_idle: "Désactiver le compte en cas d'inactivité",
        account_expires: 'Désactiver le compte',
        enforce_mfa: "Forcer l'utilisation de l'authentification à deux facteurs",
        password_expires: 'Expiration du mot de passe',
      },
    },
    operations: {
      create: 'Créer une classe de service',
      delete: 'Supprimer une classe de service',
      edit: 'Modifier une classe de service',
      sections: {
        password_policy: 'Mot de passe utilisateur',
        sip_password_policy: 'Mot de passe SIP',
        users_policy: 'Politiques des utilisateurs',
        details: 'Détails',
        office_hours: 'Heures de bureau',
      },
    },
    helperTexts: {
      users_policy: {
        password_expires: 'Nombre de jours après lequel le mot de passe doit être modifié',
        account_disable_when_idle:
          'Jours après lesquels un utilisateur inactif sera automatiquement désactivé. Une valeur de zéro signifie que la vérification ne sera pas activée',
        account_expires: 'Nombre de jours après lesquels le compte expirera',
        enforce_mfa:
          'Jours après lesquels un utilisateur inactif sera automatiquement désactivé. Une valeur de zéro signifie que la vérification ne sera pas activée',
      },
      password_policy: {
        history:
          "Longueur de l'historique des mots de passe. Les mots de passe déjà utilisés la dernière fois ne seront pas acceptés lors des opérations de changement de mot de passe ou de mise à jour de l'utilisateur",
      },
    },
    errors: {
      password_policy: {
        minLength: 'Le mot de passe doit contenir au moins %{minLength} caractères',
        maxLength: 'Le mot de passe doit contenir au plus %{maxLength} caractères',
        minUppercase: 'Le mot de passe doit contenir au moins %{minUppercase} majuscules',
        minLowercase: 'Le mot de passe doit contenir au moins %{minLowercase} minuscules',
        minNumbers: 'Le mot de passe doit contenir au moins %{minNumbers} chiffres',
        minSpecials: 'Le mot de passe doit contenir au moins %{minSpecials} caractères spéciaux',
      },
    },
  },
};
